export default {
  1: "bronze",
  2: "silver",
  3: "gold",
  4: "starter",
  6: "zampos",
};
